import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import checkboxClasses from './Checkbox.module.scss';

export const CHECKBOX_STATES = {
  Checked: 'Checked',
  Indeterminate: 'Indeterminate',
  Empty: 'Empty',
};
export function CheckboxLabel({ children }) {
  return <span className={checkboxClasses.label}>{children}</span>;
}
export function Checkbox({ id, onChange, value, isChecked, isIndeterminate }) {
  const checkboxRef = useRef();

  return (
    <input
      ref={checkboxRef}
      type="checkbox"
      data-indeterminate={isIndeterminate === true}
      id={id}
      className={checkboxClasses.checkbox}
      onChange={onChange}
      value={value}
      checked={isChecked === CHECKBOX_STATES.Checked}
    />
  );
}

export default function CheckboxContainer({
  id,
  label,
  prefix,
  suffix,
  className,
  onChange,
  value,
  checked,
  isIndeterminate,
  customStyle,
  onChangeContainer,
}) {
  const cn = cx(checkboxClasses.field, className);
  return (
    <div
      className={cn}
      style={customStyle}
      onClick={onChangeContainer}
      aria-hidden="true"
      role="button"
      tabIndex="0"
    >
      {prefix}
      <label htmlFor={id} className={checkboxClasses.container}>
        <Checkbox
          id={id}
          onChange={onChange}
          value={value}
          isChecked={checked}
          isIndeterminate={isIndeterminate}
        />
        <CheckboxLabel>{label}</CheckboxLabel>
      </label>
      {suffix}
    </div>
  );
}

const stringOrBoolean = PropTypes.oneOfType([PropTypes.string, PropTypes.bool]);
CheckboxLabel.propTypes = {
  children: PropTypes.node,
};
Checkbox.propTypes = {
  id: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  isChecked: stringOrBoolean,
  isIndeterminate: stringOrBoolean,
};
CheckboxContainer.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  className: PropTypes.string,
  onChange: PropTypes.func,
  onChangeContainer: PropTypes.func,
  value: PropTypes.string.isRequired,
  checked: stringOrBoolean,
  isIndeterminate: stringOrBoolean,
  customStyle: PropTypes.object,
};
